<template>
    <div id="song-page">
        <song></song>

        <song-editor></song-editor>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import store from '@/stores';
import * as types from '@/stores/types';
import Song from '@/components/Song.vue';
import SongEditor from '@/components/SongEditor.vue';
import SongModel from '@/models/Song';

export default {
    name:       'song-page',
    store,
    components: {
        Song,
        SongEditor,
    },
    mounted: function()
    {
        this.loadSong();
    },
    computed: {
        ...mapGetters({
            songs:       'songs',
            editionMode: 'editionMode',
        }),
    },
    methods: {
        ...mapActions({
            loadSongAction:       types.A_SONG_LOAD,
            setEditionModeAction: types.A_SONG_SET_EDITION_MODE,
        }),
        /**
         * Chargement d'une chanson
         *
         * @author Fabien Bellanger
         */
        loadSong: function()
        {
            const routeParameters = this.$route.params;
            let song              = new SongModel();

            if (routeParameters.id !== undefined)
            {
                // Chargement d'une chanson
                // ------------------------
                const songSelected = this.songs.find((element) =>
                {
                    return element.id === routeParameters.id;
                });

                if (songSelected !== undefined)
                {
                    song.init(songSelected);
                }
            }
            else
            {
                this.setEditionModeAction(true);
            }

            this.loadSongAction(song);
        },
    },
};
</script>

<style scoped lang="scss">
    #song-page {
        overflow-x:    auto;
        margin-bottom: 20px;
    }
</style>
